import { render, staticRenderFns } from "./ModalDetalleOpciones.vue?vue&type=template&id=60f7d92f"
import script from "./ModalDetalleOpciones.vue?vue&type=script&lang=js"
export * from "./ModalDetalleOpciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports